<template>

</template>

<script>
export default {
  name: "Profile",
  metaInfo: {
    title: 'Profile',
  },
}
</script>

<style scoped>

</style>